export default __webpack_public_path__ + "static/media/milestone 1600.55052f3e.svg";